import React from 'react';

import { ScrollArea, Left, ScrollContainer, ScrollContent } from './styles';

import { useIAmode } from '~/hooks/iamode';

import Chat from './Chat';

const Scroll: React.FC = ({ children }) => {
  const { enable } = useIAmode();
  

  return (
    <ScrollArea>
      <ScrollContainer>
        <ScrollContent>
          <>{children}</>
        </ScrollContent>
      </ScrollContainer>
      {enable ? (
        <Left>
          <Chat />
        </Left>
      ) : null}
    </ScrollArea>
  );
};

export default Scroll;
